module.exports = __webpack_public_path__ + "static/media/journey-bottom-img.757dd2da.png";